import { createSelector } from 'reselect';

export const getUsersAccesor = state => state.users.users; //folder-reducer

export const usersSelector = createSelector(getUsersAccesor, users => users);
